import { IApplicationState } from '../../types/redux';

export const isPromoOffersEnabledSelector = (state: IApplicationState) => {
  return state.promoOffersSelection.isEnabled;
};
